import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Close: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 19.0002L19 5.00005M19 19.0002L5 5.00005"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Close;
